import { render, staticRenderFns } from "./CardNavire.vue?vue&type=template&id=704346e8&scoped=true&"
import script from "./CardNavire.vue?vue&type=script&lang=js&"
export * from "./CardNavire.vue?vue&type=script&lang=js&"
import style0 from "./CardNavire.vue?vue&type=style&index=0&id=704346e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704346e8",
  null
  
)

export default component.exports